import { Controller } from "@hotwired/stimulus"

let apiReady

export default class extends Controller {
  static targets = ["widget", "status"]
  static values = { siteKey: String }

  connect() {
    if (!apiReady) {
      apiReady = new Promise((resolve, reject) => {
        const script = document.createElement("script")
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit"
        script.async = true
        script.onload = resolve
        script.onerror = () => {
          script.remove()
          apiReady = undefined
          reject(new Error("Turnstile unavailable"))
        }
        document.head.appendChild(script)
      })
    }

    apiReady.then(() => {
      if (!this.element.isConnected) return
      this.widgetId = window.turnstile.render(this.widgetTarget, {
        sitekey: this.siteKeyValue,
        action: "login",
        appearance: "interaction-only",
        callback: () => { this.statusTarget.textContent = "" },
        "before-interactive-callback": () => {
          this.statusTarget.textContent = "Dokončete prosím ověření v políčku výše."
        },
        "expired-callback": () => {
          this.statusTarget.textContent = "Obnovuje se ověření proti robotům…"
        },
        "error-callback": () => { this.showError() }
      })
    }).catch(() => { if (this.element.isConnected) this.showError() })
  }

  disconnect() {
    if (this.widgetId !== undefined) window.turnstile.remove(this.widgetId)
    this.widgetId = undefined
  }

  showError() {
    this.statusTarget.textContent = "Ověření proti robotům není dostupné. Obnovte stránku a zkuste to znovu."
  }
}
